import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useStatusSelectOptions } from "components/UI/Selects/StatusSelectSearchable/useStatusSelectOptions.ts";

export const StatusSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useStatusSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.state"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
